import { PROCESS } from "../../data/content";
import { Reveal } from "../motion/Motion";

export default function Process() {
  return (
    <section
      id="folyamat"
      data-testid="process-section"
      className="relative bg-brand-primary py-20 text-white md:py-32"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-12">
        <div className="mb-10 flex flex-col gap-6 md:mb-16 md:flex-row md:items-end md:justify-between">
          <div>
            <Reveal>
              <p className="mb-5 flex items-center gap-3 font-mono text-xs uppercase tracking-[0.25em] text-brand-accent">
                <span className="h-px w-10 bg-brand-accent" />
                Munkafolyamat
              </p>
            </Reveal>
            <Reveal delay={0.05}>
              <h2 className="max-w-2xl font-heading text-3xl font-extrabold leading-[1.08] tracking-tight text-white sm:text-4xl lg:text-5xl">
                Az együttműködés öt egyszerű lépésben
              </h2>
            </Reveal>
          </div>
        </div>

        <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-5 lg:gap-4">
          {PROCESS.map((step, i) => (
            <Reveal key={step.number} delay={i * 0.1}>
              <div className="group relative border-t border-white/15 pt-6">
                <span className="font-mono text-4xl font-bold text-brand-accent">
                  {step.number}
                </span>
                <h3 className="mt-4 font-heading text-lg font-bold text-white">
                  {step.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-white/60">
                  {step.description}
                </p>
                {i < PROCESS.length - 1 && (
                  <span className="absolute right-0 top-0 hidden h-px w-0 bg-brand-accent transition-all duration-500 group-hover:w-full lg:block" />
                )}
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
